export interface CheckStatisticsParams {
    taskId: string;
}

export interface CheckStatisticsResponse {
    /**
     * 问题数量
     */
    issues: number;
    /**
     * 扫描字数
     */
    scanned_word: number;
    /**
     * 耗时
     */
    spend_time: number;
}

export interface CheckStatisticsApi {
    checkStatistics: (params: CheckStatisticsParams) => Promise<CheckStatisticsResponse>;
}

export const CheckStatisticsApi = Symbol.for('CheckStatisticsApi');
